const today='2025-12-26';// 12.14放在代码最顶部（比如<head>里的<script>标签开头）
window.DateUtils = window.DateUtils || {}; // 避免重复定义
// 修复DateUtils.getTodayDate（防止本地日期篡改）
window.DateUtils.getTodayDate = function() {
  // 禁用测试日期（正式环境必须保留）
  if (calendarState?._testDate) {
    alert('⚠️ 测试日期已禁用！');
    delete calendarState._testDate;
  }
  // 用UTC日期，避免时区/本地日期篡改
  const now = new Date();
  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()).toISOString().split('T')[0];
};


async function getServerDate() {
  try {
    // 方案1：调用你的后端接口（推荐，替换为真实接口）
    const res = await fetch('https://service-iniushop.xyz/api/get-server-date');
    if (res.ok) {
      const data = await res.json();
      if (data.success && data.date) {
        return data.date; // 后端返回格式：YYYY-MM-DD
      }
    }
    
    // 方案2：兜底调用公共UTC时间接口（无需后端开发）
    const publicRes = await fetch('https://worldtimeapi.org/api/ip');
    if (publicRes.ok) { // ⚠️ 必须加这个检查！
      const publicData = await publicRes.json();
      return new Date(publicData.utc_datetime).toISOString().split('T')[0];
    }

    // ⚠️ 修复：如果上面两个都失败，执行兜底逻辑
    throw new Error('Both API calls failed');

  } catch (error) {
    // 终极兜底：用加密的本地日期（篡改即失效）
    const today = new Date().toISOString().split('T')[0];
    const encryptKey = 'iniu_xmas_2025'; // 自定义加密密钥
    const encryptedDate = btoa(today + encryptKey); // 加密
    
    // 如果本地有旧的加密日期，且和当前不符 → 判定为篡改
    if (localStorage.getItem('safe_date') && localStorage.getItem('safe_date') !== encryptedDate) {
      alert('time error ');
      return 'tampered'; // 返回篡改标记
    }
    localStorage.setItem('safe_date', encryptedDate);
    return today;
  }
}

// 圣诞日历 - 服务器存储方案
class ServerStorage {
  constructor() {
    this.email = null;
    this.serverURL = 'https://service-iniushop.xyz';
    this.totalSpent = 0;
  }

  setTotalSpent(spent) {
    this.totalSpent = spent;
  }

  setEmail(email) {
    this.email = email;
  }

  async save(state) {
    if (!this.email) throw new Error('need email address');

    try {
      console.log('💾 保存数据到服务器');
      
      const response = await fetch(`${this.serverURL}/api/save-calendar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.email,
          data: state
        })
      });

      const result = await response.json();
      
      if (result.success) {
        console.log('✅ 数据保存到服务器成功');
        return true;
      } else {
        throw new Error(result.error || '保存失败');
      }
      
    } catch (error) {
      console.error('服务器保存失败:', error);
      throw error;
    }
  }

  async load() {
    if (!this.email) return null;

    try {
      console.log('📂 从服务器加载数据');
      
      const response = await fetch(`${this.serverURL}/api/load-calendar?email=${encodeURIComponent(this.email)}`);
      const result = await response.json();
      
      if (result.success) {
        console.log('✅ 服务器响应成功');
        return result.data;
      } else {
        if (result.error && result.error.includes('不存在')) {
          return null;
        }
        throw new Error(result.error || '加载失败');
      }
    } catch (error) {
      console.error('服务器加载失败:', error);
      return null;
    }
  }
}


// 状态管理
const calendarState = {
  subscribed: false,
  claimedDays: [],
  collectedFragments: [],
  lastClaimedDay: null,
  email: null,
  lastClaimDate: null,
  selectedDiscounts: {},
  drawParticipated: false,
   // 新增：抽奖次数限制（核心防重复）
  drawRecord: {
    lastDrawDate: null,  // 最后抽奖日期（YYYY-MM-DD）
    dailyDrawCount: 0    // 当日抽奖次数
  }
};

// 奖励配置
const rewards = {
  1: { type: 'fragment', fragmentId: 1 },
  2: { type: 'image', title: 'INIU Christmas wallpaper', background: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/1-1_46fec0b9-7a57-4013-91a5-69201ad6abf6.jpg?v=1763913582', content: '' },
  3: { type: 'text', title: 'Special Mission!' },
  4: { type: 'fragment', fragmentId: 2 },
  5: { type: 'image', title: 'Christmas Facts<br> You Probably Didn’t Know', content: 'Male reindeer shed their antlers in winter, but females keep theirs, meaning Santa’s reindeer are likely female.', background: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/1-3_deeaa279-cea4-4f6e-a643-a4eaa5766347.jpg?v=1763913586' },
  6: { type: 'discount' },
  7: { type: 'discount' },
  8: { type: 'discount' },
  9: { type: 'fragment', fragmentId: 3 },
  10: { type: 'gift', title: 'Gift Guide - INIU P50', content:'Struggling to find the right gift? <br>Pick a color for everyone on your list.',code: 'TasteMe15', background: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Gift_Guide_-_P50.jpg?v=1764685649' },
  11: { type: 'gift', title: 'Gift Guide - W31-E1', content:'A thoughtful gift for anyone who loves convenience-power up phone,earbuds,and smartwatch in one sleek charger.',code: 'W31EXTRA15', background: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Gift_Guide_-_W31-E1.jpg?v=1764685648' },
  12: { type: 'draw' },
};

// 在奖励配置之前添加
const EVENT_CONFIG = {
  START_DATE: '2025-12-11',
  SPENDING_THRESHOLDS: {
    'US': 50,    // 美元
    'GB': 50,    // 英镑
    'UK': 50,    // 英镑
    'AT': 60,    // Austria/Osterreich（奥地利）
    'BE': 60,    // Belgium（比利时）
    'DE': 60,    // Deuschland/Germany（德国）
    'EE': 60,    // Eesti/Estonia（爱沙尼亚）
    'ES': 60,    // Espana（西班牙）
    'FI': 60,    // Finland（芬兰）
    'FR': 60,    // France（法国）
    'GR': 60,    // Greece（希腊）
    'IT': 60,    // Ltalia/Ltaly（意大利）
    'LV': 60,    // Latvija/Latvia（拉脱维亚）
    'LT': 60,    // Lietuva/Lithuania（立陶宛）
    'LU': 60,    // Luxembourg（卢森堡）
    'NL': 60,    // Nederland（荷兰）
    'PT': 60,    // Portugal（葡萄牙）
    'SI': 60,    // Slovenija（斯洛文尼亚）
    'SK': 60,    // Slovensko（斯洛伐克）
    'default': 50
  }
};
const COUNTRY_CURRENCY = {
  'US': '$',    // 美元
  'GB': '£',    // 英镑
  'UK': '£',    // 英镑
  'AT': '€',    // 奥地利
  'BE': '€',    // 比利时
  'DE': '€',    // 德国
  'EE': '€',    // 爱沙尼亚
  'ES': '€',    // 西班牙
  'FI': '€',    // 芬兰
  'FR': '€',    // 法国
  'GR': '€',    // 希腊
  'IT': '€',    // 意大利
  'LV': '€',    // 拉脱维亚
  'LT': '€',    // 立陶宛
  'LU': '€',    // 卢森堡
  'NL': '€',    // 荷兰
  'PT': '€',    // 葡萄牙
  'SI': '€',    // 斯洛文尼亚
  'SK': '€',    // 斯洛伐克
  'default': '$' 
};

// 创建存储实例
const storage = new ServerStorage();

// DOM 元素
let lockOverlay, unlockButton, rewardModal, rewardDisplay, fragmentProgress, headerSubscribeBtn, currentSpent, unlockBtn;


// 日期工具函数（保持不变）
// class DateUtils {

//   static getTodayDate() {
//     // 如果有测试日期，使用测试日期
//     if (calendarState._testDate) {
//       return calendarState._testDate;
//     }
//     // 否则使用真实日期
//     return new Date().toISOString().split('T')[0];
//   }

//   static isSameDay(date1, date2) {
//     return date1 === date2;
//   }

//   static getCurrentDayOfMonth() {
//     return new Date().getDate();
//   }

//   static canClaimReward(dayNumber, lastClaimDate, claimedDays) {
//     const today = this.getTodayDate();
    
//     if (this.isSameDay(lastClaimDate, today) && !claimedDays.includes(dayNumber) && dayNumber != 12) {
//       return { canClaim: false, reason: 'You have already claimed reward today' };
//     }
    
//     return { canClaim: true };
//   }
// }

// 12.14日期工具函数（清理测试逻辑 + 加固防篡改）
class DateUtils {
  // 获取真实日期（彻底删除测试日期逻辑）
  static getTodayDate() {
    // 禁用测试日期（彻底杜绝篡改）
    if (calendarState?._testDate) {
      alert('time error');
      delete calendarState._testDate;
    }
    // 使用UTC日期，避免本地时区/日期篡改
    const now = new Date();
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()).toISOString().split('T')[0];
  }

  static isSameDay(date1, date2) {
    if (!date1 || !date2) {
      return false;
    }
    return date1 === date2;
  }

  static getCurrentDayOfMonth() {
    // 关键修复：用UTC日期的日，而非本地日期
    return new Date().getUTCDate();
  }

  // static async canClaimReward(dayNumber, lastClaimDate, claimedDays) {

  //   // 1. 先获取服务器真实日期（核心！不再用本地日期）
  //   const today = await getServerDate();
  //   if(dayNumber == 12){
  //     return { canClaim: true };
  //   }
  //   // 2. 检测到日期篡改 → 直接禁止领取
  //   if (today === 'tampered') {
  //     return { canClaim: false, reason: 'Date tampering detected' };
  //   }

  //   // const today = this.getTodayDate();
    
  //   // 核心修复：无论是否12号，同一天只能领1个（彻底堵死改日期领多个的漏洞）
  //   if (this.isSameDay(lastClaimDate, today)) {
  //     // 只要当天领过任何一个，就不能再领
  //     return { canClaim: false, reason: 'You have already claimed reward today' };
  //   }
    
  //   // 额外：已领过的日期不能重复领
  //   if (claimedDays.includes(dayNumber)) {
  //     return { canClaim: false, reason: 'This reward has already been claimed' };
  //   }
    
  //   return { canClaim: true };
  // }
  static async canClaimReward(dayNumber, lastClaimDate, claimedDays) {
  // ===== 核心修改1：特殊场景直接放行（不校验）=====
  // 场景1：查看已领取的礼盒（1-11号）→ 放行
  // 场景2：操作12号奖池 → 放行（12号的抽奖资格在giftDraw里单独校验）
  if (claimedDays.includes(dayNumber) || dayNumber === 12) {
    return { canClaim: true, reason: '' };
  }

  // 1. 先获取服务器真实日期（核心！不再用本地日期）
  const today = await getServerDate();
  // 2. 检测到日期篡改 → 直接禁止领取
  if (today === 'tampered') {
    return { canClaim: false, reason: 'Date tampering detected' };
  }
  
  // 核心修复：无论是否12号，同一天只能领1个（彻底堵死改日期领多个的漏洞）
  if (DateUtils.isSameDay(lastClaimDate, today)) {
    // 只要当天领过任何一个，就不能再领
    return { canClaim: false, reason: 'You have already claimed reward today' };
  }
  
  // 额外：已领过的日期不能重复领（上面已经过滤，这里是兜底）
  if (claimedDays.includes(dayNumber)) {
    return { canClaim: false, reason: 'This reward has already been claimed' };
  }
  
  return { canClaim: true };
}
}
// 初始化
document.addEventListener('DOMContentLoaded', function() {
  console.log('🎄 圣诞日历初始化 - 服务器存储方案');

  initializeDOMElements();
  initEventListeners();
  
  checkUserSubscriptionState ();
});

// 初始化DOM元素
function initializeDOMElements() {
  lockOverlay = document.getElementById('lockOverlay');
  unlockButton = document.getElementById('unlockButton');
  rewardModal = document.getElementById('rewardModal');
  rewardDisplay = document.getElementById('rewardDisplay');
  fragmentProgress = document.getElementById('fragmentProgress');
  headerSubscribeBtn = document.getElementById('headerSubscribeBtn');
  currentSpent = document.getElementById('currentSpent');
  unlockBtn = document.getElementById('unlockbtn');
}

// 添加全局状态跟踪
let isSubscribing = false;

// 修改检查用户订阅状态函数
async function checkUserSubscriptionState() {

  try {
    
    // 如果用户已登录，检查是否已订阅
    if (window.customerData && window.customerData.loggedIn && window.customerData.email) {
      console.log('✅ 用户已登录:', window.customerData.email);

      storage.setEmail(window.customerData.email);

      
       // 从服务器加载数据
      const userData = await storage.load();
      console.log('📊 加载到的用户数据:', userData);


      if(window.customerData.acceptsMarketing){

        if(!userData) {
          console.log('没有userdata');
          const initialData = {
            subscribed: true,
            email: window.customerData.email,
            claimedDays: [],
            collectedFragments: [],
            lastClaimedDay: null,
            lastClaimDate: null,
            subscribedAt: new Date().toISOString(),
            manuallySubscribed: true
          };
          
          // 保存订阅数据到服务器
          await storage.save(initialData);
          // 更新本地状态
          Object.assign(calendarState, initialData);
        } else {         
          userData.subscribed = true;
          storage.save(userData);
        }
      }
    
      if (userData && userData.subscribed) {
        // 恢复状态
        Object.assign(calendarState, userData);
        showUnlockedState();
      } else {
        console.log('❌ 用户未订阅或数据不存在');
      }
      
      const spent = await getCustomerOrders(window.customerData.id) || 0;
      const userCountry = window.customerData.country;
      const currencySymbol = COUNTRY_CURRENCY[userCountry] || '$';
      currentSpent.textContent = `${currencySymbol} ${spent}`;

      if(spent >= EVENT_CONFIG.SPENDING_THRESHOLDS[window.customerData.country]){
        unlockBtn.disabled = false;
      }
      storage.setTotalSpent(spent);
      calendarState.totalSpent = spent;
      
    } else {
      // 用户未登录，显示锁定状态
      console.log('❌ 用户未登录，显示锁定状态');
    }
    
  } catch (error) {
    console.error('检查失败:', error);
  }
}
//12.14新增



// 显示解锁状态
function showUnlockedState() {
  if (lockOverlay && calendarState.subscribed) lockOverlay.style.display = 'none';
  // 更新头部订阅按钮状态为已订阅
  updateSubscribeButtonState();
  updateCalendarDisplay();
}

// 显示锁定状态
function showLockedState() {
  if (lockOverlay) lockOverlay.style.display = 'flex';
  // 更新头部订阅按钮状态为可订阅
  updateSubscribeButtonState();
  initEventListeners();
  updateCalendarDisplay();
}

// 更新订阅按钮状态
function updateSubscribeButtonState() {
  const headerSubscribeBtn = document.getElementById('headerSubscribeBtn');
  if (headerSubscribeBtn) {
    if (calendarState.subscribed) {
      headerSubscribeBtn.textContent = 'Already Subscribed';
      headerSubscribeBtn.disabled = true;
      headerSubscribeBtn.classList.add('subscribed');
    } else {
      headerSubscribeBtn.textContent = 'Subscribe to Unlock';
      headerSubscribeBtn.disabled = false;
      headerSubscribeBtn.classList.remove('subscribed', 'loading');
    }
  }
}

// 事件监听器
function initEventListeners() {
  // if (!unlockButton) {
  //   console.error('未找到解锁按钮');
  //   return;
  // }
  
  // 解锁按钮点击事件 - 只处理已登录用户的订阅
  // 注意：这里假设只有已登录用户才会看到可点击的div，未登录用户看到的是a链接
  if(unlockButton){
    unlockButton.addEventListener('click', function() {
      handleUnlockClick();
    });
  }


  // 头部订阅按钮点击事件
  if (headerSubscribeBtn) {
    headerSubscribeBtn.addEventListener('click', function() {
      handleUnlockClick();
    });
  }

  unlockBtn.addEventListener('click', function() {
    claimReward(12);
  })

  // 关闭按钮
  document.querySelectorAll('.close').forEach(function(closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (rewardModal) rewardModal.style.display = 'none';
    });
  });

  // 日期点击事件
  document.querySelectorAll('.day').forEach(function(day) {
    day.addEventListener('click', function() {
      // console.log('点击day=====');
      // if (!calendarState.subscribed) {
      //   showNotification('🔒 Subsscribe to unlock calender');
      //   return;
      // }
      
      const dayNumber = parseInt(this.dataset.day);
      claimReward(dayNumber);
    });
  });

  // 模态框外部点击关闭
  window.addEventListener('click', function(e) {
    if (e.target === rewardModal) {
      rewardModal.style.display = 'none';
    }
  });
}

// 处理解锁点击
async function handleUnlockClick() {

  if (isSubscribing) {
    console.log('⏳ 订阅进行中，跳过重复点击');
    return;
  }


  // 这个函数现在只会在已登录用户点击时被调用
  try {
    await addCustomerTag('xmas-email-subscribe');

    isSubscribing = true;
    showNotification('🔄 subscribing...');
    
    const email = window.customerData.email;

    const data = await storage.load();
    if(data) {
      Object.assign(calendarState, data);
      calendarState.subscribed = true;
      await storage.save(calendarState);
    } else {
      // 初始化用户数据
      const initialData = {
        subscribed: true,
        email: email,
        claimedDays: [],
        collectedFragments: [],
        lastClaimedDay: null,
        lastClaimDate: null,
        subscribedAt: new Date().toISOString(),
        manuallySubscribed: true,
        drawRecord: {  // 新增这行
    lastDrawDate: null,
    dailyDrawCount: 0
  }
      };
      
      // 保存订阅数据到服务器
      await storage.save(initialData);
      
      // 更新本地状态
      Object.assign(calendarState, initialData);
    }
    
    
    // 显示解锁状态
    showUnlockedState();
    showNotification('Subscription successful! Calendar unlocked.');
    
  } catch (error) {
    console.error('订阅失败:', error);
    showNotification('Subscription failed, please try again.');
  } finally {
    isSubscribing = false;
  }
}

// 领取奖励
async function claimReward(dayNumber) {
  // if (!calendarState.subscribed) {
  //   showNotification('Subscribe to unlock calendar');
  //   return;
  // }
  //   if (dayNumber === 12) {
  //   const eligibility = checkDrawEligibility();
  //   if (!eligibility.eligible) {
  //     showNotification(`❌ ${eligibility.reason}`);
  //     return;
  //   }
  // }

  // 保存原始状态（用于回滚）
  const originalState = {
    lastClaimedDay: calendarState.lastClaimedDay,
    lastClaimDate: calendarState.lastClaimDate
  };

  const canClaim = await DateUtils.canClaimReward(dayNumber, calendarState.lastClaimDate, calendarState.claimedDays);
  
  // 测试阶段先注释
  if (!canClaim.canClaim) {
    showNotification(`${canClaim.reason}`);
    return;
  }

  const reward = rewards[dayNumber];
  if (!reward) {
    showNotification('reward configuration error');
    return;
  }
  if(dayNumber == 12 || calendarState.claimedDays.includes(dayNumber)){
    showReward(reward, dayNumber);
    return;
  }

  try {
    calendarState.claimedDays.push(dayNumber);
    calendarState.lastClaimedDay = dayNumber;
    // calendarState.lastClaimDate = DateUtils.getTodayDate();
    // 【关键修改】用服务器日期更新领取时间
    calendarState.lastClaimDate = canClaim.serverDate || await getServerDate();
    

    if (reward.type === 'fragment' && !calendarState.collectedFragments.includes(reward.fragmentId)) {
      calendarState.collectedFragments.push(reward.fragmentId);
    }

    await storage.save(calendarState);
    
    showReward(reward, dayNumber);
    updateCalendarDisplay();
    
    showNotification('Reward claimed successfully！');
    
  } catch (error) {
    console.error('领取奖励失败:', error);
    showNotification('Reward claimed failed');
    
    calendarState.claimedDays = calendarState.claimedDays.filter(d => d !== dayNumber);
    if (reward.type === 'fragment') {
      calendarState.collectedFragments = calendarState.collectedFragments.filter(f => f !== reward.fragmentId);
    }
    calendarState.lastClaimedDay = originalState.lastClaimedDay;
    calendarState.lastClaimDate = originalState.lastClaimDate;
  }
}

// 显示奖励
function showReward(reward, dayNumber) {
  if (!rewardDisplay) {
    console.error('未找到奖励显示容器');
    return;
  }
  
  let rewardHTML = '';
  
  switch (reward.type) {
    case 'image':
      rewardHTML = `
        <div class="reward-image reward-background" style="background-image: url(${reward.background}); background-size: 100% 100%;">
          <span style="color: #969696">Day ${dayNumber}</span>
          <h2>${reward.title}</h2>
          <p class="reward-tab-title" style="color: #454545; font-weight: bold; max-width: 500px; margin: 0 auto;text-align: center;">${reward.content}</p>
        </div>
      `;
      break;
      
    case 'fragment':
      rewardHTML = `
        <div class="reward-fragment">
          <span style="color: #969696">Day ${dayNumber}</span>
          <h2>INIU D5CC Cable Shard(${calendarState.collectedFragments.length}/3)</h2>
          <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/D5cc_b9a160b3-26da-49a3-a7bf-8ece945da080.jpg?v=1763913354" style="max-width: 25%;">
          <p style="color: #454545;">Collect all shards (now: ${calendarState.collectedFragments.length}/3) to redeem!</p>
          <button class="subscribe-btn" ${calendarState.collectedFragments.length >=3 && !calendarState.fragmentRedeemed ? '' : 'disabled'} onclick="showAddressForm('INIU D5CC Cable Shard')">Redeem</button>
        </div>
      `;
      break;
      
    case 'draw':
  //     // 12.14替换原有 isEligibleForDraw 逻辑，改用统一的校验函数（和 giftDraw 保持一致）
  // 复用统一校验函数，规则和giftDraw中完全一致
  const eligibility = checkDrawEligibility();
  const limitCheck = checkDailyDrawLimit();
  const isEligibleForDraw = eligibility.eligible;
  //  (async () => {
  //   const eligibility = checkDrawEligibility();
  //   const limitCheck = await checkDailyDrawLimit(); // 加await
  //   const isEligibleForDraw = eligibility.eligible;
    
  //   // 重新渲染按钮（替换原有硬编码的按钮逻辑）
  //   const drawButton = document.querySelector('.subscribe-btn[onclick="giftDraw()"]');
  //   if (drawButton) {
  //     drawButton.disabled = !calendarState.drawParticipated && isEligibleForDraw && limitCheck.canDraw ? false : true;
  //     drawButton.style.cssText = !calendarState.drawParticipated && isEligibleForDraw && limitCheck.canDraw 
  //       ? '' 
  //       : 'cursor: not-allowed; opacity: 0.6; background-color: #cccccc;';
  //   }
  // })();
    // const isEligibleForDraw = storage.totalSpent >= EVENT_CONFIG.SPENDING_THRESHOLDS[window.customerData.country] || (calendarState.claimedDays.length >= 11 && DateUtils.isSameDay(calendarState.lastClaimDate, DateUtils.getTodayDate()));
      // const claimedToday = ;
      rewardHTML = `
        <div class="reward-image">
          <span style="color: #969696">Day ${dayNumber}</span>
          <h2>Enter to win</h2>
          <p style="color: #454545; font-weight: bold;font-size:20px;margin:0 0 10px;">Unlocks on your 12th day!</p>
          <div style="display: flex; justify-content: center">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/P62.jpg?v=1763913415" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/P41_21d5ad4e-aebf-45b5-9edc-70f92c85f58a.jpg?v=1763913422" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/250.jpg?v=1763913462" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Amazon_giftcard.jpg?v=1763913478" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/15_067961ab-e2d6-465b-91a8-00de167ec677.jpg?v=1763913457" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/5_bf238c62-6c90-4593-be2e-0fa561d89c8f.jpg?v=1763913454" style="max-width: 13%;">
            <img src="https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Product_tester.jpg?v=1763913544" style="max-width: 13%;">
          </div>
          <p style="color: #454545;">you’ve earned one lucky draw chance 🎁 - Everyone wins!<br> Prizes include: INIU Gift Cards ($5 / $15 / $250), $100 Amazon Gift Card,<br> INIU P62 Power Bank, INIU P41 Power Bank, 2026 Product Tester Pass.</p>
       <button class="subscribe-btn" onclick="giftDraw()" 
        ${!calendarState.drawParticipated && isEligibleForDraw && limitCheck.canDraw ? '' : 'disabled'}
        style="${!calendarState.drawParticipated && isEligibleForDraw && limitCheck.canDraw ? '' : 'cursor: not-allowed; opacity: 0.6; background-color: #cccccc;'}">
        DRAW NOW
      </button>
          </div>
      `;
      break;

    case 'gift':
      rewardHTML = `
        <div class="reward-image" style="background-image: url(${reward.background}); background-size: cover; border-radius: 15px;">
          <span style="color: #969696">Day ${dayNumber}</span>
          <h2>${reward.title}</h2>
           <p class="reward-tab-title" style="max-width: 450px; margin: 0 auto;text-align: center;">${reward.content}</p>
          <div class="gift-btn">
            <span style="font-weight: bold; margin-right: 10px">15% off Today!</span>
            <span>CODE: ${reward.code}</span>
            <button onclick="copyDiscountCode('${reward.code}')" style="color: #9D9D9D; cursor: pointer; border: none; background: none; text-decoration: underline; font-size: 16px;">copy</button>
          </div>
        </div>
      `;
      break;

      case 'text':
      rewardHTML = `
        <div class="reward-image">
          <span style="color: #969696">Day ${dayNumber}</span>
          <h2>Special Mission! </h2>
          <p style="color: #454545; font-weight: bold;margin-bottom:0;">Join our Giveaway to become INIU’s 2026 Product Tester! </p>
          <p style="color: #454545;margin:0;">Get 12 products (one each month in 2026), including best-sellers & new launches</p>
          <p style="color: #454545; margin-top: 25px;">
                  Join via the post on Instagram 
                 <span style="text-decoration: underline;">@iniuofficial</span> 
                       or TikTok 
                 <span style="text-decoration: underline;">@iniuofficial</span>
          </p>
        </div>
      `;
      break;

      case 'discount':
              // 获取当前日期之前的选择（如果有）
      const previousSelection = calendarState.selectedDiscounts[dayNumber];
      const getDiscountButtonHTML = (code) => {
        if(!previousSelection) {
          // 正常可选状态
          return `
            <button class="discount-btn discount-btn-card" 
                    onclick="selectDiscount('${code}', this, ${dayNumber})" 
                    >
              Choose this
            </button>
          `;
        }

        const isSelected = (previousSelection === code);
        
        if (isSelected) {
          // 如果之前选过这个，显示为已选中状态
          return `
            <button class="discount-btn discount-btn-choose" 
                    onclick="selectDiscount('${code}', this, ${dayNumber})" 
                    disabled>
              ${code}
            </button>
          `;
        } else {
          // 不可选
          return `
            <button class="discount-btn discount-btn-unchoose" 
                    onclick="selectDiscount('${code}', this, ${dayNumber})" 
                    disabled>
              Choose this
            </button>
          `;
        }
      };
  rewardHTML = `
    <div class="reward-discount">
      <span style="color: #969696">Day ${dayNumber}</span>
      <h2>Limited Time Code</h2>
      <p class="reward-tab-title">valid from 12.12-1.10</p>
      <p style="color: #666; font-size: 14px; margin-bottom: 20px;">Choose one discount option (code will auto-copy):</p>
      <div style="display: flex; gap: 5px; justify-content: center;">
        <div class="discount-option">
          <div class="discount-tab">
            <div style="font-weight: 700; ">Buy 1</div>
            <div class="discount-p">for extra 5% off</div>
            ${getDiscountButtonHTML('XB6JM7HKQE3C')}
          </div>
        </div>
        
        <div class="discount-option">
          <div class="discount-tab">
            <div style="font-weight: 700;">Buy 2</div>
            <div class="discount-p">for extra 8% off</div>
            ${getDiscountButtonHTML('9RQ9W6WNY2P1')}
          </div>
        </div>
        
        <div class="discount-option">
          <div class="discount-tab">
            <div style="font-weight: 700;">Buy 3</div>
            <div class="discount-p">for extra 10% off</div>
            ${getDiscountButtonHTML('4MMRXSNQYKK5')}
          </div>
        </div>
      </div>
    </div>
  `;
  break;
  }

  rewardDisplay.innerHTML = rewardHTML;
  if (rewardModal) {
    rewardModal.style.display = 'block';
  }
}

// 选择折扣码（增强版）
function selectDiscount(code, button, dayNumber) {
  // 获取所有折扣按钮和选项容器
  const allButtons = document.querySelectorAll('.discount-btn');
  const allOptions = document.querySelectorAll('.discount-option');
  
  // 重置所有按钮状态
  allButtons.forEach(btn => {
      btn.disabled = true;
      btn.style.cursor = 'default';
  });
  
  // 重置所有选项容器样式
  allOptions.forEach(option => {
    const innerDiv = option.querySelector('div');
    innerDiv.style.opacity = '0.6';
  });
  
  // 设置当前选中的按钮
  button.textContent = code;
  
  // 设置当前选中的选项容器
  const currentOption = button.closest('.discount-option');
  const currentInner = currentOption.querySelector('div');
  currentInner.style.opacity = '1';

  calendarState.selectedDiscounts[dayNumber] = code;
  
  // 自动复制折扣码
  copyDiscountCode(code);

  saveDiscountSelection(dayNumber, code);

}

async function saveDiscountSelection(dayNumber, code) {
  try {
    await storage.save(calendarState);
    console.log(`✅ 折扣选择已保存: 第${dayNumber}天 -> ${code}`);
  } catch (error) {
    console.error('保存折扣选择失败:', error);
    // 可以在这里添加用户提示
  }
}

function copyDiscountCode(code) {
  navigator.clipboard.writeText(code).then(function() {
    showNotification('Discount code copied to clipboard: ' + code);
  }).catch(function() {
    showNotification('Copy failed, please copy manually: ' + code);
  });
}


// 抽奖奖品配置
const drawPrizes = [
  { 
    name: 'INIU $5 Gift Card', 
    probability: 54.9,
    type: 'giftcard',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/5_bf238c62-6c90-4593-be2e-0fa561d89c8f.jpg?v=1763913454',
    tag: 'christmas_giftcard_5'
  },
  { 
    name: 'INIU $15 Gift Card', 
    probability: 25,
    type: 'giftcard',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/15_067961ab-e2d6-465b-91a8-00de167ec677.jpg?v=1763913457',
    tag: 'christmas_giftcard_15'
  },
  { 
    name: 'INIU $250 Gift Card', 
    probability: 0,
    type: 'giftcard',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/250.jpg?v=1763913462',
    tag: 'christmas_giftcard_250'
  },
  { 
    name: 'INIU P41 Power Bank', 
    probability: 10,
    type: 'physical',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/P41_21d5ad4e-aebf-45b5-9edc-70f92c85f58a.jpg?v=1763913422'
  },
  { 
    name: 'INIU P62 Power Bank', 
    probability: 10,
    type: 'physical',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/P62.jpg?v=1763913415'
  },
  { 
    name: '2026 Product Tester Pass', 
    probability: 0.1,
    type: 'physical',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Product_tester.jpg?v=1763913544'
  },
  { 
    name: '$100 Amazon Gift Card', 
    probability: 0,
    type: 'giftcard',
    image: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/Amazon_giftcard.jpg?v=1763913478',
    tag: 'amazon_giftcard_100'
  }
];
// 12.14 新增：统一校验抽奖资格（核心权限控制）
function checkDrawEligibility() {
  // 1. 基础校验：用户必须已订阅
  if (!calendarState.subscribed) {
    return { eligible: false, reason: 'You need to subscribe first' };
  }

  // 2. 获取用户国家（兜底默认值）
  const userCountry = window.customerData?.country || 'default';
  // 3. 获取消费门槛
  const threshold = EVENT_CONFIG.SPENDING_THRESHOLDS[userCountry] || EVENT_CONFIG.SPENDING_THRESHOLDS.default;
  // 4. 消费金额达标（无日期限制）
  const isSpentEnough = storage.totalSpent >= threshold;
  // 5. 前11天全部领取（排除12号）
  const isAll11DaysClaimed = calendarState.claimedDays.filter(day => day < 12).length >= 11;
  // 6. 领完11号的日期不是当天（你的核心限制）
  const isAfterClaim11thDay = isAll11DaysClaimed 
    ? !DateUtils.isSameDay(calendarState.lastClaimDate, DateUtils.getTodayDate()) 
    : false;

  // 最终资格：消费达标 OR（领完11天 + 隔了一天）
  if (isSpentEnough || (isAll11DaysClaimed && isAfterClaim11thDay)) {
    return { eligible: true, reason: '' };
  } else if (isAll11DaysClaimed && !isAfterClaim11thDay) {
    // 领完11天但没隔一天，单独提示
    return { eligible: false, reason: 'You can unlock the draw the day after claiming all 11 rewards' };
  } else {
    return { 
      eligible: false, 
      reason: 'You need to claim all 11 days rewards (and wait one day) or spend over ' + 
              (COUNTRY_CURRENCY[userCountry] || COUNTRY_CURRENCY.default) + threshold + 
              ' to unlock the draw' 
    };
  }
}
// 12.14新增：校验当日抽奖次数（核心限制逻辑）
// function checkDailyDrawLimit() {
//   const today = DateUtils.getTodayDate();
//   const drawRecord = calendarState.drawRecord || { lastDrawDate: null, dailyDrawCount: 0 };

//   // 新增：如果已参与过抽奖（drawParticipated为true），直接永久禁用
//   if (calendarState.drawParticipated) {
//     return {
//       canDraw: false,
//       needReset: false,
//       reason: 'You have already participated in the draw and cannot draw again'
//     };
//   }

//   // 原有每日限制逻辑
//   if (!drawRecord.lastDrawDate || drawRecord.lastDrawDate !== today) {
//     return {
//       canDraw: true,
//       needReset: true
//     };
//   }

//   return {
//     canDraw: drawRecord.dailyDrawCount < 1,
//     needReset: false,
//     reason: 'You can only draw once per day'
//   };
// }
// 替换后的完整函数（直接粘贴）
window.checkDailyDrawLimit = async function() { // 注意加async（因为有await）
  // 规则1：抽过12号 → 永久不能抽（核心）
  if (calendarState.drawParticipated) {
    return { canDraw: false, needReset: false, reason: 'You have already participated in the draw and cannot draw again' };
  }

  // 规则2：获取服务器当前时间（关键！不再用本地日期）
  let serverDate = null;
  try {
    // 调用公共时间接口（测试用，正式环境替换为你的后端接口）
    const res = await fetch('https://worldtimeapi.org/api/ip');
    const data = await res.json();
    serverDate = new Date(data.utc_datetime).toISOString().split('T')[0];
  } catch (e) {
    // 降级方案：用本地日期，但加密存储，防止篡改
    serverDate = DateUtils.getTodayDate();
    // 把日期加密存储到localStorage，篡改本地日期也没用
    const encryptDate = btoa(serverDate); // 简单加密
    if (localStorage.getItem('drawServerDate') && localStorage.getItem('drawServerDate') !== encryptDate) {
      // alert('⚠️ 检测到日期篡改，禁止抽奖！');
      return { canDraw: false, needReset: false, reason: 'Date tampering detected' };
    }
    localStorage.setItem('drawServerDate', encryptDate);
  }

  // 规则3：对比服务器时间，判断是否同一天抽过
  if (calendarState.drawRecord?.lastDrawDate === serverDate) {
    // 当天已抽过 → 禁止
    return { canDraw: false, needReset: false, reason: 'You can only draw once per day' };
  }

  // 可以抽奖
  return { canDraw: true, needReset: true, reason: '', serverDate: serverDate };
};


// 12.14 抽奖函数（修改后，新增校验逻辑）
async function giftDraw() {
  try {
    console.log('🎰 开始抽奖...');
    
    // 校验抽奖资格（包含永久限制）
    const eligibility = checkDrawEligibility();
    if (!eligibility.eligible) {
      showNotification(`❌ ${eligibility.reason}`);
      return;
    }

   const limitCheck = await checkDailyDrawLimit();
    if (!limitCheck.canDraw) {
      showNotification(`❌ ${limitCheck.reason}`);
      return;
    }

    // 禁用抽奖按钮
    const drawButton = document.querySelector('.subscribe-btn[onclick="giftDraw()"]');
    if (drawButton) {
      drawButton.disabled = true;
      drawButton.textContent = 'Drawing...';
      drawButton.style.opacity = '0.6';
    }

    // 执行抽奖
    const prize = performDraw();
    console.log('🎉 get prize:', prize);

    // // 更新抽奖记录
    // if (!calendarState.drawRecord) {
    //   calendarState.drawRecord = { lastDrawDate: null, dailyDrawCount: 0 };
    // }
    // if (limitCheck.needReset) {
    //   calendarState.drawRecord.lastDrawDate = DateUtils.getTodayDate();
    //   calendarState.drawRecord.dailyDrawCount = 1;
    // } else {
    //   calendarState.drawRecord.dailyDrawCount += 1;
    // }
    // 原giftDraw中更新抽奖记录的部分
if (limitCheck.needReset) {
  calendarState.drawRecord.lastDrawDate = limitCheck.serverDate || DateUtils.getTodayDate(); // 优先用服务器日期
  calendarState.drawRecord.dailyDrawCount = 1;
} else {
  calendarState.drawRecord.dailyDrawCount += 1;
}

    // 核心：永久标记已参与抽奖（抽过就不能再抽）
    calendarState.drawParticipated = true; // 这个值一旦为true，永久禁用
    calendarState.drawParticipatedAt = new Date().toISOString();
    calendarState.lastDrawPrize = prize.name;
    
    // 12号日期块标记为「已抽奖」（永久状态）
    const day12 = document.querySelector('.day-12');
    if (day12) {
      day12.classList.add('claimed');
      day12.classList.remove('unlocked', 'disabled');
      day12.title = '已参与抽奖，无法再次抽奖'; // 提示文字更新
    }
    
    // 保存状态到服务器（关键：永久状态同步到服务端）
    await storage.save(calendarState);
    
    // 显示抽奖结果
    showDrawResult(prize);

    // 礼品卡标签添加
    if (prize.type === 'giftcard' && prize.tag) {
      await addCustomerTag(prize.tag);
    }
    
  } catch (error) {
    console.error('抽奖失败:', error);
    showNotification('❌ Something went wrong, please try again');
    
    // 恢复按钮状态
    const drawButton = document.querySelector('.subscribe-btn[onclick="giftDraw()"]');
    if (drawButton) {
      drawButton.disabled = false;
      drawButton.textContent = 'DRAW NOW';
      drawButton.style.opacity = '1';
    }
  }
}
// 抽奖函数
// async function giftDraw() {
//   try {
//     console.log('🎰 开始抽奖...');
    
//     // 禁用抽奖按钮防止重复点击
//     const drawButton = document.querySelector('.subscribe-btn[onclick="giftDraw()"]');
//     if (drawButton) {
//       drawButton.disabled = true;
//       drawButton.textContent = 'Drawing...';
//       drawButton.style.opacity = '0.6';
//     }

//     // 执行抽奖
//     const prize = performDraw();
    
//     console.log('🎉 抽中奖品:', prize);

//     // 标记用户已参与抽奖
//     calendarState.drawParticipated = true;
//     calendarState.drawParticipatedAt = new Date().toISOString();
//     calendarState.lastDrawPrize = prize.name;
//     calendarState.claimedDays.push(12);
//     calendarState.lastClaimedDay = 12;
//     calendarState.lastClaimDate = DateUtils.getTodayDate();
//     const day12 = document.querySelector('.day-12');
//     day12.classList.add('claimed');
//     day12.classList.remove('unlocked', 'disabled');
    
//     // 保存状态到服务器
//     await storage.save(calendarState);
    
//     // 显示抽奖结果
//     showDrawResult(prize);

    
//     // 如果是礼品卡类型，为用户添加标签
//     if (prize.type === 'giftcard' && prize.tag) {
//       await addCustomerTag(prize.tag);
//     }
    
//   } catch (error) {
//     console.error('抽奖失败:', error);
//     showNotification('❌ Something went wrong, please try again');
    
//     // 重新启用抽奖按钮
//     const drawButton = document.querySelector('.subscribe-btn[onclick="giftDraw()"]');
//     if (drawButton) {
//       drawButton.disabled = false;
//       drawButton.textContent = 'DRAW NOW';
//       drawButton.style.opacity = '1';
//     }
//   }
// }

// 执行抽奖逻辑
function performDraw() {
  // 测试用
  // return drawPrizes[3];
  // 生成随机数 (0-100)
  const random = Math.random() * 100;
  let cumulativeProbability = 0;
  
  // 遍历奖品，根据概率确定中奖奖品
  for (const prize of drawPrizes) {
    cumulativeProbability += prize.probability;
    if (random <= cumulativeProbability) {
      return prize;
    }
  }
  
  // 如果所有概率都不匹配（理论上不会发生），返回第一个奖品
  return drawPrizes[0];
}

// 显示抽奖结果
function showDrawResult(prize) {
  if (!rewardDisplay) return;
  
  let resultHTML = '';
  
  if (prize.type === 'giftcard') {
    // 礼品卡类型 - 显示恭喜信息
    resultHTML = `
      <div class="reward-draw-result" style="text-align: center; padding: 20px;">
        <span style="color: #969696">Day 12</span>
        <h2 style="margin: 20px 0;">Congratulations! </h2>
        <img src="${prize.image}" style="max-width: 115px; border-radius: 10px; margin: 15px 0;">
        <p style="color: #cccccc; margin: 10px 0;">
          You’ve unlocked ${prize.name}!<br>You will be contacted via email within 3 business days.
        </p>
      </div>
    `;
  } else {
    // 实物奖品类型 - 显示地址收集表单
    resultHTML = `
      <div class="reward-draw-result" style="text-align: center; padding: 20px;">
        <span style="color: #969696">Day 12</span>
        <h2 style="margin: 20px 0;">Congratulations! </h2>
        <img src="${prize.image}" style="max-width: 115px; border-radius: 10px; margin: 15px 0;">
        <p style="color: #cccccc; margin: 10px 0;">
          You’ve unlocked the ${prize.name} product!<br>Your gift will be shipped within 5 business days.
        </p>

        <div style="margin-top: 30px;">
          <button class="subscribe-btn" onclick="showAddressForm('${prize.name}')" style="padding: 12px 30px; border-radius: 25px; font-weight: bold; cursor: pointer;">
            Get it now
          </button>
        </div>
      </div>
    `;
  }
  
  rewardDisplay.innerHTML = resultHTML;
}

// 显示地址收集弹窗
function showAddressForm(prizeName) {
  if (!rewardDisplay) return;
  
  const addressHTML = `
    <div>
      <div class="address-form-modal" style="text-align: center; max-width: 500px; width: 90%; margin: 0 auto; box-sizing: border-box;">
        
        <!-- 地址收集表单：添加max-height和overflow-y，避免内容溢出 -->
        <div id="addressForm" style="text-align: left; background: rgba(255,255,255); padding: 25px; border-radius: 10px; max-height: 100vh; overflow-y: auto;">
          <h2 style="margin-bottom: 20px; text-align: center;">Shipping Details</h2>
          
          <div style="margin-bottom: 15px;">
            <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">Full Name *</label>
            <input type="text" id="fullName" placeholder="Enter your full name" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
          </div>
          
          <div style="margin-bottom: 15px;">
            <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">Address *</label>
            <input type="text" id="address" placeholder="Enter your street address" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
          </div>
          
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
            <div>
              <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">City *</label>
              <input type="text" id="city" placeholder="City" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
            </div>
            <div>
              <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">State/Province *</label>
              <input type="text" id="state" placeholder="State" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
            </div>
          </div>
          
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px;">
            <div>
              <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">ZIP/Postal Code *</label>
              <input type="text" id="zipCode" placeholder="ZIP Code" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
            </div>
            <div>
              <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">Country *</label>
              <input type="text" id="country" placeholder="Country" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
            </div>
          </div>
          
           <div style="margin-bottom: 15px;">
            <label style="color: #cccccc; display: block; margin-bottom: 8px; font-size: 14px;">Phone *</label>
            <input type="text" id="Phone" placeholder="Enter your Phone Number" style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; background: rgba(255,255,255,0.9); font-size: 14px;" required>
          </div>

          <div style="display: flex; gap: 15px; justify-content: center; margin-top: 25px; flex-wrap: wrap;">
            <button class="subscribe-btn" onclick="submitAddress('${prizeName}')" style="border: none; padding: 12px 40px; border-radius: 25px; font-weight: bold; cursor: pointer; font-size: 16px;">
              Submit Address
            </button>
            <button class="subscribe-btn" onclick="closeModal()" style="background: transparent; color: #000000; border: 1px solid #cccccc; padding: 12px 30px; border-radius: 25px; font-weight: bold; cursor: pointer; font-size: 16px;">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  `;
  
  rewardDisplay.innerHTML = addressHTML;
}

async function getCustomerOrders(customerId) {
  const response = await fetch(
    `https://service-iniushop.xyz/api/customer-orders/${customerId}?start_date=${EVENT_CONFIG.START_DATE}`
  );
  
  if (!response.ok) {
    throw new Error('获取订单失败');
  }
  const res = await response.json();
  console.log('CustomerOrders', res);
  // 按货币累加
  let totals = 0;
  
  res.orders.forEach(order => {
    // ✅ 使用 current_total_price (自动扣除退款)
    
    totals += parseFloat(order.current_total_price);
    
    console.log(`订单 ${order.name}: ${order.currency} ${order.current_total_price} (状态: ${order.financial_status})`);
  });
  
  return totals;
}

// 为用户添加标签（礼品卡类型）
async function addCustomerTag(tag) {
  try {
    console.log('🏷️ 为用户添加标签:', tag);
    
    // 这里需要调用Shopify API来为用户添加标签
    
    const response = await fetch('https://service-iniushop.xyz/api/add-customer-tag', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: `gid://shopify/Customer/${window.customerData.id}`,
        tags: tag
      })
    });
    
    if (response.ok) {
      console.log('✅ 标签添加成功');
      showNotification('Gift Card has been sent to your email');
    } else {
      console.warn('⚠️ 标签添加失败，但抽奖结果有效');
    }
    
  } catch (error) {
    console.error('添加标签失败:', error);
    // 即使标签添加失败，也不影响抽奖结果
  }
}

// 提交地址信息（实物奖品类型）
async function submitAddress(prizeName) {
  try {
    // 获取表单数据
    const addressData = {
      fullName: document.getElementById('fullName').value,
      address: document.getElementById('address').value,
      city: document.getElementById('city').value,
      state: document.getElementById('state').value,
      zipCode: document.getElementById('zipCode').value,
      country: document.getElementById('country').value,
      Phone: document.getElementById('Phone').value,
      prize: prizeName,
      email: calendarState.email,
      submittedAt:DateUtils.getTodayDate()
    };
    
    // 验证必填字段
    if (!addressData.fullName || !addressData.address || !addressData.city || 
        !addressData.state || !addressData.zipCode || !addressData.country) {
      showNotification(' Fill out all required fields');
      return;
    }
    
    console.log('📦 提交地址信息:', addressData);

    if (!calendarState.shippingAddresses) {
      calendarState.shippingAddresses = [];
    }
    
    // 检查是否已有相同奖品的地址
    const existingIndex = calendarState.shippingAddresses.findIndex(
      addr => addr.prize === prizeName
    );
    
    if (existingIndex !== -1) {
      // 更新现有地址
      calendarState.shippingAddresses[existingIndex] = addressData;
    } else {
      // 添加新地址
      calendarState.shippingAddresses.push(addressData);
    }
    
    // 保存到服务器（使用 save-calendar 接口）
    await storage.save(calendarState);
    calendarState.fragmentRedeemed = true;

    showNotification('Address submitted successfully!');
    closeModal();
    
  } catch (error) {
    console.error('提交地址失败:', error);
    showNotification('Address submitted failed, please try again');
  }
}

// 关闭模态框
function closeModal() {
  if (rewardModal) {
    rewardModal.style.display = 'none';
  }
}


function showNotification(message) {
  const existingNotifications = document.querySelectorAll('.calendar-notification');
  existingNotifications.forEach(notification => notification.remove());
  
  const notification = document.createElement('div');
  notification.className = 'calendar-notification';
  notification.style.cssText = `
    position: fixed;
    top: 30px;
    right: 30px;
    background: #ffffff;
    color: #000000;
    padding: 12px 20px;
    border-radius: 20px;
    border: 1px solid transparent;
    z-index: 1000;
    font-weight: 400;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    font-size:14px;
  `;
  notification.textContent = message;
  document.body.appendChild(notification);
  
  setTimeout(function() {
    if (notification.parentNode) {
      notification.parentNode.removeChild(notification);
    }
  }, 3000);
}

// function updateCalendarDisplay() {
   
//   const currentDay = DateUtils.getCurrentDayOfMonth();
  
//   document.querySelectorAll('.day').forEach(function(day) {
//     const dayNumber = parseInt(day.dataset.day);
//     const canClaim = DateUtils.canClaimReward(dayNumber,  calendarState.lastClaimDate,  calendarState.claimedDays);
    
//     if (calendarState.claimedDays.includes(dayNumber)) {
//       day.classList.add('claimed');
//       day.classList.remove('unlocked', 'disabled');
//       day.title = '已领取';
//     }
//      else if (canClaim.canClaim) {
//       day.classList.add('unlocked');
//       day.classList.remove('claimed', 'disabled');
//       day.title = '点击领取';
//     } else {
//       day.classList.add('disabled');
//       day.classList.remove('unlocked', 'claimed');
      
//     if (!canClaim.canClaim) {
//         day.title = canClaim.reason;
//       }
//     }
//   });
  
// }

//12.14新增
function updateCalendarDisplay() {
  const currentDay = DateUtils.getCurrentDayOfMonth();
  
  document.querySelectorAll('.day').forEach(function(day) {
    const dayNumber = parseInt(day.dataset.day);
    const canClaim = DateUtils.canClaimReward(dayNumber,  calendarState.lastClaimDate,  calendarState.claimedDays);

    // ===== 新增：12号日期块特殊处理 =====
    if (dayNumber === 12) {
      // 12号日期块始终禁用（靠unlockBtn打开弹窗，不是点击日期块）
      day.classList.add('disabled');
      day.classList.remove('unlocked', 'claimed');
      return;
    }
    
    // 你原有的1-11号逻辑（完全保留，满足每天随机抽1个）
    if (calendarState.claimedDays.includes(dayNumber)) {
      day.classList.add('claimed');
      day.classList.remove('unlocked', 'disabled');
    } else if (canClaim.canClaim) {
      day.classList.add('unlocked');
      day.classList.remove('claimed', 'disabled');
    } else {
      day.classList.add('disabled');
      day.classList.remove('unlocked', 'claimed');
      if (!canClaim.canClaim) {
        day.title = canClaim.reason;
      }
    }
  });
}

// // 添加这些函数到你的代码中
// function testDateUtils() {
//   console.log('🎯 日期测试工具');
//   console.log('当前日期:', DateUtils.getTodayDate());
//   console.log('上次领取日期:', calendarState.lastClaimDate);
//   console.log('是否可以领取:', DateUtils.canClaimReward(calendarState.lastClaimDate));
  
//   // 创建一个测试菜单
//   const testMenu = `
//     🧪 日期测试菜单:
//     1. testSetDate('2024-12-24') - 设置测试日期
//     2. testSimulateNextDay() - 模拟到第二天
//     3. testCanClaim() - 测试是否可领取
//     4. testResetDate() - 重置为真实日期
//   `;
//   console.log(testMenu);
// }

// // 在控制台可用的测试函数
// window.testSetDate = function(dateString) {
//   calendarState._testDate = dateString;
//   console.log('📅 设置测试日期为:', dateString);
  
//   // 重新检查是否可以领取
//   const result = DateUtils.canClaimReward(calendarState.lastClaimDate);
//   console.log('领取检查结果:', result);
  
//   updateCalendarDisplay();
//   showNotification(`测试日期设置为: ${dateString}`);
// };

// window.testSimulateNextDay = function() {
//   if (!calendarState._testDate) {
//     console.error('请先设置测试日期');
//     return;
//   }
  
//   const currentDate = new Date(calendarState._testDate);
//   currentDate.setDate(currentDate.getDate() + 1);
//   calendarState._testDate = currentDate.toISOString().split('T')[0];
  
//   console.log('⏭️ 日期前进一天:', calendarState._testDate);
  
//   updateCalendarDisplay();
//   showNotification(`模拟到新的一天: ${calendarState._testDate}`);
// };

// window.testResetDate = function() {
//   calendarState._testDate = null;
//   console.log('🔄 重置为真实日期');
//   updateCalendarDisplay();
//   showNotification('已重置为真实日期');
// };
